import React from 'react';
import { Form } from 'semantic-ui-react';
import styled from 'styled-components';
import { Field } from 'formik';
import PropTypes from 'prop-types';

import Required from '../Required';
import ErrorMessage from '../ErrorMessage';
import InputBtn from './inputBtn';

// From Semantic CSS
const StyledField = styled(Field)`
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  margin: 0em;
  outline: none;
  -webkit-appearance: none;
  tap-highlight-color: rgba(255, 255, 255, 0);
  line-height: 1.21428571em;
  padding: 0.60714286em 1em;
  font-size: 1em;
  background: #ffffff;
  border: 1px solid rgba(34, 36, 38, 0.15);
  color: rgba(0, 0, 0, 0.87);
  border-radius: 0.28571429rem;
  box-shadow: 0em 0em 0em 0em transparent inset;
  -webkit-transition: color 0.1s ease, border-color 0.1s ease;
  transition: color 0.1s ease, border-color 0.1s ease;
  width: 100%;
  vertical-align: top;
  ${(props) => (props.uppercase ? 'text-transform: uppercase;' : '')}

  &:focus {
    color: rgba(0, 0, 0, 0.95);
    border-color: #85b7d9;
    border-radius: 0.28571429rem;
    background: #ffffff;
    box-shadow: 0px 0em 0em 0em rgba(34, 36, 38, 0.35) inset;
  }

  &:disabled {
    background-color: #f5f5f5;
    color: rgba(0, 0, 0, 0.6);
    border-color: rgba(34, 36, 38, 0.15);
    cursor: not-allowed;
    opacity: 1;
  }
`;

export const Input = ({
  touched,
  errors,
  type,
  name,
  label,
  checked,
  disabled,
  required,
  style,
  placeholder,
  onBlur,
  uppercase,
  btn,
  onFocus,
  onClick,
  readOnly,
}) => (
  <Form.Field error={Boolean(touched[name] && errors[name])} style={style}>
    <label htmlFor={name}>
      {label}
      <Required required={required} />
    </label>
    <StyledField {...{ type, name, checked, disabled, placeholder, onBlur, uppercase, onFocus, onClick, readOnly }} />
    {btn && <InputBtn {...btn} />}
    {touched[name] && errors[name] && <ErrorMessage>{errors[name]}</ErrorMessage>}
  </Form.Field>
);

Input.propTypes = {
  touched: PropTypes.object,
  errors: PropTypes.object,
  type: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  style: PropTypes.object,
  placeholder: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func,
  uppercase: PropTypes.bool,
  btn: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  readOnly: PropTypes.bool,
};

export default Input;



// WEBPACK FOOTER //
// ./app/components/Forms/UI/Input/input.js